<template>
  <v-text-field
    :label="renderLabel"
    v-model="val"
    :outlined="outlined"
    :readonly="readonly"
    :dense="dense"
    :class="renderClasses"
    v-on:keyup.enter="$event.target.blur()"
    type="text" />
</template>

<script>
import InputMixin from './mixins/InputMixin'

export default {
  name: '',

  mixins: [
    InputMixin
  ],

  methods: {
    isValueTypeValid (value) {
      return typeof value === 'number' || typeof value === 'string'
    }
  }
}
</script>
